import axios from "axios";

function normalizeApiBaseUrl() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL?.trim();
  const apiUrl = process.env.REACT_APP_API_URL?.trim();

  if (backendUrl) {
    return `${backendUrl.replace(/\/$/, "")}/api`;
  }

  if (apiUrl) {
    return apiUrl.replace(/\/$/, "");
  }

  return "/api";
}

export const API_BASE_URL = normalizeApiBaseUrl();

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach Authorization header if session_token is saved in localStorage (resilient against third-party cookie restrictions in iframes)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jnic_session_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
